import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'use-memo-one'

import { reatomExploreTrendingPairs } from '../../atoms/reatom-explore-trending'

import { ExploreList } from './explore-list'

import type { ExploreTrendingPairsModel } from '../../atoms/reatom-explore-trending'
import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type ExploreTrendingListProps = {
  onItemClick?: (options: { pair: PairModel }) => void
  offsetBottom?: number | string | undefined
} & ClassNameProps

export const ExploreTrendingList: React.FC<
  ExploreTrendingListProps & { model?: ExploreTrendingPairsModel }
> = ({ onItemClick, offsetBottom, model: initialModel }) => {
  const model = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => initialModel ?? reatomExploreTrendingPairs(),
    [initialModel],
  )

  const [pairsState] = useAtom(model.resolvedPairsStateAtom)
  const load = useAction(model.load)

  return (
    <ExploreList
      onItemClick={onItemClick}
      statsPeriod={model.period}
      priceChartInterval="minutes"
      onRetry={load}
      pairsState={pairsState}
      offsetBottom={offsetBottom}
    />
  )
}
